module.exports = __webpack_public_path__ + "img/1-4.9a483c54.png";